import { render, staticRenderFns } from "./TrustTitle.vue?vue&type=template&id=085c6594&scoped=true"
import script from "./TrustTitle.vue?vue&type=script&lang=js"
export * from "./TrustTitle.vue?vue&type=script&lang=js"
import style0 from "./TrustTitle.vue?vue&type=style&index=0&id=085c6594&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085c6594",
  null
  
)

export default component.exports